import React from "react";

const ComplianceTeamDashboardContext = React.createContext();
export default ComplianceTeamDashboardContext;
